import { MainIcon } from "../../helper/MainIcon";

function KopSurat() {
    return (
        <>
            <center>
                <table>
                    <tr>
                        <td width={"80%"}>
                            <div style={{ borderRight: "5px solid #000000", padding: "10px", marginRight: "10px" }}>
                                <div style={{ textAlign: "right", fontWeight: "bold", fontSize: "14px" }}>PAUD LQ Baladz</div>
                                <div style={{ textAlign: "right", fontSize: "16px" }}>TK AL QURAN BALADZ</div>
                                <div style={{ textAlign: "right", fontSize: "16px" }}><b>SDTahfidz</b> SEKOLAH SULAIMAN</div>
                                <div style={{ textAlign: "right" }}>(Home Schooling)</div>
                                <div style={{ textAlign: "right", fontSize: "12px" }}>Yayasan Baladil Huffadz International</div>
                            </div>
                        </td>
                        <td><div style={{ textAlign: "center" }}>
                            <img style={{ height: "120px" }} src={MainIcon.MainLogo()}></img>
                        </div></td>
                    </tr>
                </table>
            </center>
            <hr></hr>
        </>
    )
}

export default KopSurat;